import React, {useRef, useState} from "react";
/** @jsxImportSource @emotion/react */
import {css} from "@emotion/react";
import styled from "@emotion/styled";
import {useDispatch, useSelector} from "react-redux";
import CustomInput from "../../_common/component/CustomInput";
import CustomLabel from "../../_common/component/CustomLabel";
import {REGEX_BIRTH, REGEX_PHONE} from "../../../constant/regexs";
import {autoHyphenBirthDate, autoHyphenPhoneNumber} from "../../../common";
import CustomGenderSelect from "../../_common/component/CustomGenderSelect";
import SubmitButton from "../../_common/component/SubmitButton";
import {lang} from "../../../lang";
import {useModelContext} from "../../../context/ModelContextProvider";
import {account_actions} from "../../../redux/slice/AccountReducer";
import {useNavigate} from "react-router-dom";
import {useDialogContext} from "../../../context/DialogContextProvider";
import {getImageUrl} from "../../../context/ApplicationContextProvider";
import {useTheme} from "@emotion/react";
import Log from "../../../common/Log";
import {RIGHT_ARROW_TEXT} from "../../_presentational/texts";

const UpdateAccountForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {account_model, isSuccess, isError} = useModelContext();
    const {alert, confirm} = useDialogContext();
    const account_reducer = useSelector((state) => state.account_reducer);

    // state
    const [phone_error, setPhoneError] = useState();
    const [birth_error, setBirthError] = useState();

    // ref
    const name_ref = useRef({
        value: account_reducer.info.name,
    });
    const account_ref = useRef({
        value: account_reducer.info.account_name,
    });
    const update_user_info = useRef({
        phone: {
            value: account_reducer.info.phone ? autoHyphenPhoneNumber(account_reducer.info.phone) : null,
            error_msg: null,
        },
        birth: {
            value: account_reducer.info.birth ? autoHyphenBirthDate(account_reducer.info.birth) : null,
            error_msg: null,
        },
        gender: {
            value: account_reducer.info.gender,
            error_msg: null,
        },
    });

    // css style
    const {UpdateAccountFormSection, UpdatePasswordSection, move_to_change_password_css} = useComponentStyle();

    const onGenderChange = (gender) => {
        update_user_info.current.gender.value = gender;
    };

    const validatePhoneAndBirthValue = async () => {
        const phone_value = update_user_info.current.phone.value;
        const birth_value = update_user_info.current.birth.value;

        if (!phone_value || !birth_value) {
            !phone_value && (update_user_info.current.phone.error_msg = lang.modify_info.empty_modify_phone);
            !birth_value && (update_user_info.current.birth.error_msg = lang.modify_info.empty_modify_birth);
        }

        if (phone_value) {
            !REGEX_PHONE.test(phone_value)
                ? (update_user_info.current.phone.error_msg = lang.modify_info.check_modify_phone)
                : (update_user_info.current.phone.error_msg = null);
        }

        if (birth_value) {
            !REGEX_BIRTH.test(birth_value)
                ? (update_user_info.current.birth.error_msg = lang.modify_info.check_modify_birth)
                : (update_user_info.current.birth.error_msg = null);
        }

        if (update_user_info.current.phone.error_msg === null && update_user_info.current.birth.error_msg === null) {
            setPhoneError(false);
            setBirthError(false);
            await submitUpdate(phone_value, birth_value);
        } else {
            update_user_info.current.phone.error_msg && setPhoneError(true);
            update_user_info.current.birth.error_msg && setBirthError(true);
        }
    };

    const submitUpdate = async (phone_value, birth_value) => {
        // phone은 - 제거하여 보냄
        const phone = phone_value.replace(/[^0-9]/g, "");
        const birth = birth_value;
        const gender = update_user_info.current.gender.value;

        // 변경된 사항이 없으면 api호출 X
        if (
            phone === account_reducer.info.phone &&
            birth === account_reducer.info.birth &&
            gender === account_reducer.info.gender
        ) {
            await alert(lang.modify_info.did_not_changed);
            return false;
        } else {
            if (await confirm(lang.modify_info.confirm_update)) {
                const update_profile_res = await account_model.postUpdateProfile({phone, gender, birth});
                if (isSuccess(update_profile_res)) {
                    dispatch(account_actions.setInfo({info: update_profile_res.data.account, with_detail_info: false}));
                    await alert(lang.modify_info.success_update);
                    navigate(-1);
                } else if (isError(update_profile_res)) {
                    Log.private("postUpdateProfile 에러", update_profile_res);
                }
            }
        }
    };

    return (
        <>
            <UpdateAccountFormSection>
                <CustomInput
                    name={"account_name"}
                    need_label={true}
                    label_name={"계정"}
                    read_only={true}
                    current_value={account_ref.current}
                />
                <CustomInput
                    name={"name"}
                    need_label={true}
                    label_name={"이름"}
                    read_only={true}
                    current_value={name_ref.current}
                />
                <UpdatePasswordSection>
                    <CustomLabel htmlFor={"id_pw"} label_name={"비밀번호"} />
                    <div onClick={() => navigate("/account/update-password")}>
                        <RIGHT_ARROW_TEXT css={move_to_change_password_css}>변경하기</RIGHT_ARROW_TEXT>
                    </div>
                </UpdatePasswordSection>
                <CustomInput
                    name={"phone"}
                    placeholder={"ex) 010-1234-5678"}
                    need_label={true}
                    label_name={"휴대전화"}
                    max_length={13}
                    regex={REGEX_PHONE}
                    current_value={update_user_info.current.phone}
                    on_change={(text) => (update_user_info.current.phone.value = text)}
                    is_error={phone_error}
                />
                <CustomInput
                    name={"birth"}
                    placeholder={"ex) 2022-07-07"}
                    need_label={true}
                    label_name={"생년월일"}
                    max_length={10}
                    regex={REGEX_BIRTH}
                    current_value={update_user_info.current.birth}
                    on_change={(text) => (update_user_info.current.birth.value = text)}
                    is_error={birth_error}
                />
                <CustomGenderSelect current_value={update_user_info.current.gender.value} on_change={onGenderChange} />
                <SubmitButton on_click={validatePhoneAndBirthValue} button_text={"저장"} margin_top={"4em"} />
            </UpdateAccountFormSection>
        </>
    );
};

export default UpdateAccountForm;

export const useComponentStyle = () => {
    const theme = useTheme();
    return {
        UpdateAccountFormSection: styled.div({
            "& > div": {
                marginBottom: "3em",
            },
        }),
        UpdatePasswordSection: styled.div({
            marginBottom: "1.5em",
            "& > div:nth-of-type(2)": {
                display: "flex",
            },
        }),
        move_to_change_password_css: css({
            color: theme.colors.bearu_primary,
            fontSize: theme.font_size.f16,
            marginTop: ".5em",
            height: "2em",
            "& > .arrow-right-icon": {
                background: `url(${getImageUrl(
                    "image/common/ic_arrow_right_blue.png"
                )}) center center/contain no-repeat`,
                transform: "none",
            },
        }),
    };
};
